import { StudentCoursesDataT } from "@interfaces/internal-study/students";
import { FC } from "react";
import { Link } from "react-router-dom";
import clsx from "clsx";
import course from "@assets/images/course.webp";
import { getCourseThumbnail } from "@utils/getCompanyLogo";
import style from "@scss/pages/study-center.module.scss";

function getUrlThumbnail(thumbnail: string): string {
  if (thumbnail) return getCourseThumbnail(thumbnail);
  return course;
}

export type NewsItemPropsT = {
  course: StudentCoursesDataT;
};

export const CourseItem: FC<NewsItemPropsT> = ({ course }) => {
  return (
    <div className={clsx(style.student_courses_item)}>
      <Link to={`/course/${course.id}`}>
        <div
          className={clsx(style.student_courses_item_content, {
            [style.finish]: course.finish,
          })}
          style={{
            backgroundImage: `url(${getUrlThumbnail(
              course.course_info.thumbnail
            )})`,
          }}
        >
          <div className={clsx(style.student_courses_item_content_counters)}>
            <p
              className={clsx(
                style.student_courses_item_content_counters_text,
                style.student_courses_item_content_counters_text_all
              )}
            >
              Всего лекций: <span>{course.course_info.lessons_count}</span>
            </p>
            <p
              className={clsx(
                style.student_courses_item_content_counters_text,
                style.student_courses_item_content_counters_text_current
              )}
            >
              Пройдено лекций: <span>{course.stage}</span>
            </p>
          </div>
          <p className={clsx(style.student_courses_item_content_title)}>
            {course.course_info.title}
          </p>
        </div>
      </Link>
    </div>
  );
};
